<template>
  <div>
    <table class="field-value-table uk-table uk-table-divider uk-table-small">
      <tbody>
        <tr v-for="fieldData in details" :key="fieldData.label">
          <td v-if="fieldData.direction === 'vertical'" colspan="2" class="field-data-font">
            <div>{{ fieldData.label }}</div>

            <template v-if="fieldData.type && fieldData.type.some(t => t.toLowerCase() === 'link')">
              <a
                :href="fieldData.value"
                target="_blank"
                rel="noopener noreferrer nofollow"
                class="overflow-ellipsis"
                >{{ fieldData.value }}</a
              >
            </template>
            <template v-else>
              {{ fieldData.value }}
            </template>
          </td>

          <template v-else>
            <td
              class="uk-text-bolder field-value-table-cell field-data-font"
              :class="{
                'field-label-width': true,
              }"
            >
              {{ fieldData.label }}
            </td>
            <td
              :colspan="fieldData.label2 ? '1' : '3'"
              class="field-value-table-cell field-data-font"
              :class="{
                'field-label-width': true,
                'custom-value-width': fieldData.label2,
              }"
            >
              <template
                v-if="fieldData.type && fieldData.type.some(t => t.toLowerCase() === 'link')"
              >
                <div class="uk-flex uk-flex-middle">
                  <a
                    :href="fieldData.value"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    class="overflow-ellipsis"
                    :class="{ 'link-background': debateStatus?.rounds?.length === 0 }"
                    >{{ fieldData.value }}</a
                  >
                  <span
                    v-if="fieldData.allowCopyLink"
                    uk-icon="icon: copy;ratio: 1.5"
                    class="copy-icon-effect"
                    style="cursor: pointer"
                    :uk-tooltip="'title:Copy to Clipboard; pos: left'"
                    @click="copyLinkToClipboard(fieldData.value)"
                  />
                </div>
              </template>
              <template v-else>
                <input
                  v-if="
                    fieldData.type &&
                    fieldData.editable &&
                    fieldData.type.some(t => t.toLowerCase() === 'date')
                  "
                  type="date"
                  class="uk-input"
                  v-model="fieldData.value"
                  @input="setDisableButton()"
                />
                <input
                  v-else-if="fieldData.editable"
                  type="text"
                  class="uk-input"
                  v-model="fieldData.value"
                  @input="setDisableButton()"
                />
                <template v-else>
                  <span v-html="fieldData.value" />
                </template>
              </template>
            </td>
            <template v-if="fieldData.label2">
              <td
                colspan="1"
                class="uk-text-bolder field-value-table-cell field-data-font"
                :class="{
                  'field-label-width': true,
                }"
              >
                {{ fieldData.label2 }}
              </td>
              <td
                colspan="1"
                class="field-value-table-cell field-data-font"
                :class="{
                  [`uk-width-${columnWidths ? columnWidths[1] : '2-3'}`]: true,
                }"
              >
                <template
                  v-if="fieldData.type2 && fieldData.type2.some(t => t.toLowerCase() === 'link')"
                >
                  <div class="uk-flex uk-flex-middle">
                    <a
                      :href="fieldData.value2"
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      class="overflow-ellipsis"
                      >{{ fieldData.value2 }}</a
                    >
                    <span
                      v-if="fieldData.allowCopyLink"
                      uk-icon="icon: copy;ratio: 1.5"
                      class="copy-icon-effect"
                      style="cursor: pointer"
                      :uk-tooltip="'title:Copy to Clipboard; pos: left'"
                      @click="copyLinkToClipboard(fieldData.value2)"
                    />
                  </div>
                </template>
                <template v-else>
                  <input
                    v-if="
                      fieldData.type2 &&
                      fieldData.editable2 &&
                      fieldData.type2.some(t => t.toLowerCase() === 'date')
                    "
                    type="date"
                    class="uk-input"
                    v-model="fieldData.value2"
                    @input="setDisableButton()"
                  />
                  <input
                    v-else-if="fieldData.editable2"
                    type="text"
                    class="uk-input"
                    v-model="fieldData.value2"
                    @input="setDisableButton()"
                  />
                  <template v-else>
                    <span
                      v-html="fieldData.value2"
                      :class="{
                        'custom-date-background':
                          debateStatus?.rounds?.length === 0 &&
                          debateNextState?.current_status !== 'Published',
                      }"
                    />
                  </template>
                </template>
              </td>
            </template>
          </template>
        </tr>
        <template v-if="isCustomField">
          <tr>
            <td
              class="uk-text-bolder field-value-table-cell field-data-font"
              :class="{ 'field-label-width': true }"
            >
              Custom Fields:
            </td>
            <td class="uk-text-right" colspan="3">
              <button type="button" class="btn-custom-field" @click="custonFieldHandle">
                <img
                  :class="{ 'rotate-arrow': !open }"
                  src="/icons/black/icon-black-outline-node.svg"
                />
              </button>
            </td>
          </tr>
          <tr
            :class="{ customFieldToggle: open }"
            style="border: none"
            v-for="(field, i) in customFields"
            :key="i"
          >
            <td
              class="field-value-table-cell field-data-font"
              :class="{
                'field-label-width': true,
              }"
            >
              <input
                type="text"
                class="uk-input"
                v-model="field.name"
                placeholder="custom label"
                @input="setDisableButton()"
              />
            </td>
            <td class="field-value-table-cell field-data-font" colspan="3">
              <div class="uk-flex">
                <input
                  type="text"
                  v-model="field.value"
                  class="uk-input"
                  placeholder="custom value"
                  @input="setDisableButton()"
                />
                <button
                  @click="removecustomField(i)"
                  type="button"
                  class="btn-remove uk-button uk-button-default uk-border-circle uk-padding-remove uk-margin-left"
                >
                  <i
                    uk-icon="icon: ban; ratio:1.1"
                    class="ban-icon"
                    uk-tooltip="Remove Custom Field"
                  ></i>
                </button>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div
      v-if="isCustomField"
      :class="{ customFieldToggle: open }"
      class="uk-flex uk-flex-between uk-flex-baseline add-btn-padding"
    >
      <button
        v-if="permissionLevel !== PermissionLevel.COHORT"
        class="uk-button uk-button-default uk-border-rounded"
        type="button"
        @click="addCustomField"
      >
        <span>Add +</span>
      </button>
      <button
        v-if="(saveBtn || !open) && permissionLevel !== PermissionLevel.COHORT"
        class="uk-button-primary uk-border-rounded padding-btn"
        :class="{ 'disable-btn-save': btnDisable }"
        @click="updateUserData()"
      >
        Save
      </button>
    </div>
    <OppositionInviteModal />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import PermissionLevel from '@/assets/js/enum/PermissionLevel';
import { mapActions, mapGetters, mapState } from 'vuex';
import { EventBus } from '@/assets/js/event-bus';

export default {
  name: 'FieldValueTable',
  props: {
    fields: Array,
    data: Object,
    columnWidths: Array,
    saveBtn: {
      type: Boolean,
      default: false,
    },
    isCustomField: {
      type: Boolean,
      default: false,
    },
    isDebateView: {
      type: Boolean,
      default: false,
    },
    customFieldData: Array,
  },
  components: {
    OppositionInviteModal: defineAsyncComponent(
      () => import('@/components/annotations/OppositionInviteModal.vue')
    ),
  },
  data() {
    return {
      btnDisable: true,
      open: true,
      customFields: [],
    };
  },
  computed: {
    PermissionLevel() {
      return PermissionLevel;
    },
    EventBus() {
      return EventBus;
    },
    ...mapState(['currentTeam', 'debateStatus', 'debateNextState']),
    ...mapGetters(['permissionLevel']),

    details() {
      return this.fields.map(f => {
        return {
          ...f,
          value:
            f.type && f.type.some(t => t.toLowerCase() === 'date') && f.field === 'createdAt'
              ? this.data[f.field] && new Date(this.data[f.field]).toString() !== 'Invalid Date'
                ? new Date(this.data[f.field]).toLocaleDateString('en-us', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  })
                : '-'
              : f.type &&
                  f.type.some(t => t.toLowerCase() === 'date') &&
                  f.field === 'publicationDate'
                ? (() => {
                    const inputDate = this.data[f.field];
                    const dateOnly = inputDate.split(' ')[0];
                    const parts = dateOnly.split('-');
                    const formattedDate =
                      parts.length === 3
                        ? `${parts[0]}-${parts[1].padStart(2, '0')}-${parts[2].padStart(2, '0')}`
                        : this.data[f.field];
                    return formattedDate;
                  })()
                : f.type && f.type.some(t => t.toLowerCase() === 'custom')
                  ? this.data[f.field].value
                  : f.type && f.type.some(t => t.toLowerCase() === 'function')
                    ? f.field()
                    : f.type && f.type.some(t => t.toLowerCase() === 'array')
                      ? f.field
                      : this.data[f.field],
          value2:
            f.type2 && f.type2.some(t => t.toLowerCase() === 'date') && f.field2 === 'createdAt'
              ? new Date(this.data[f.field2]).toLocaleDateString('en-us', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric',
                }) === 'Invalid Date'
                ? this.data[f.field2]
                : new Date(this.data[f.field2]).toLocaleDateString('en-us', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  })
              : f.type2 &&
                  f.type2.some(t => t.toLowerCase() === 'date') &&
                  f.field2 === 'publicationDate' &&
                  f.editable2
                ? (() => {
                    const inputDate2 = this.data[f.field2];
                    const dateOnly2 = inputDate2.split(' ')[0];
                    const parts2 = dateOnly2.split('-');
                    const formattedDate2 =
                      parts2.length === 3
                        ? `${parts2[0]}-${parts2[1].padStart(2, '0')}-${parts2[2].padStart(2, '0')}`
                        : this.data[f.field2];
                    return formattedDate2;
                  })()
                : f.type2 &&
                    f.type2.some(t => t.toLowerCase() === 'date') &&
                    f.field2 === 'publicationDate' &&
                    !f.editable2
                  ? new Date(this.data[f.field2]).toLocaleDateString('en-us', {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric',
                    }) === 'Invalid Date'
                    ? this.data[f.field2]
                    : new Date(this.data[f.field2].split('-').join('/')).toLocaleDateString(
                        'en-us',
                        { day: '2-digit', month: '2-digit', year: 'numeric' }
                      )
                  : f.type2 && f.type2.some(t => t.toLowerCase() === 'custom')
                    ? this.data[f.field2].value
                    : f.type2 && f.type2.some(t => t.toLowerCase() === 'function')
                      ? f.field2()
                      : f.type2 && f.type2.some(t => t.toLowerCase() === 'array')
                        ? f.field2
                        : this.data[f.field2],
        };
      });
    },
  },
  mounted() {
    if (this.customFieldData?.length) {
      this.customFields = this.customFieldData;
      this.open = false;
    }
  },
  created() {
    if (this.debateStatus?.rounds?.length === 0 || this.customFieldData?.length) {
      this.open = false;
    }
  },
  watch: {
    btnDisable(value) {
      EventBus.emit('framing.save.button', value);
      if (value === false) {
        window.onbeforeunload = function (e) {
          if (this.btnDisable === false) {
            e = e || window.event;
            if (e) {
              e.returnValue = 'Sure?';
            }
            return 'Sure?';
          }
        }.bind(this);
      }
    },
    customFieldData() {
      if (this.customFieldData?.length) {
        this.customFields = this.customFieldData;
        this.open = false;
      }
    },
    open(val) {
      EventBus.emit('custom.field.open', val);
    },
  },
  methods: {
    ...mapActions(['updateDocument', 'updateTeam']),

    custonFieldHandle() {
      this.open = !this.open;
    },

    copyLinkToClipboard(link) {
      navigator.clipboard.writeText(link);
    },
    setDisableButton() {
      this.btnDisable = false;
    },
    updateUserData() {
      this.btnDisable = true;
      let body = {};
      this.details.map(data => {
        if (data.editable) {
          body = {
            ...body,
            [data.field]: data.value,
          };
        }
      });
      if (Object.keys(body).length) {
        this.updateDocument({ documentData: body, setData: true });
      }
      if (this.customFields.filter(field => field.name && field.value).length) {
        this.updateTeam({
          teamID: this.currentTeam._id,
          updatedData: { custom_fields: this.customFields },
        });
      }
    },

    addCustomField() {
      this.setDisableButton();
      this.customFields.push({
        name: '',
        value: '',
      });
    },

    removecustomField(index) {
      this.setDisableButton();
      this.customFields = this.customFields.filter((item, i) => index !== i);
    },
  },
};
</script>

<style lang="sass" scoped>
.field-value-table
  word-break: break-word
  margin-bottom: 0px !important
  &-cell
    word-break: initial

.overflow-ellipsis
  overflow: hidden
  word-break: break-all
  text-overflow: ellipsis
  -webkit-line-clamp: 1
  display: -webkit-box
  -webkit-box-orient: vertical

.disable-btn-save
  pointer-events: none
  opacity: 0.5

.padding-btn
  padding: 2px 20px
  height: 40px

.ban-icon
  color: #9F1D35

.customFieldToggle
  display: none

.btn-custom-field
  border: none
  height: 30px
  border-radius: 10px
.rotate-arrow
  transform: rotate(180deg)
.field-label-width
  width: 33%
.custom-value-width
  width: 50%
.custom-date-background
  background: #f8f8f8
  padding: 8px
  border: 2px solid #516d79
  border-radius: 5px
  font-size: medium
  padding-right: 42%
.link-background
  border: 2px solid #516d79
  width: 98%
  border-radius: 5px
  font-size: medium
  padding: 4px
  background: #f8f8f8

.add-btn-padding
  padding: 10px
</style>
